<template>
  <div class="static-page">
    <div class="basic">
      <div class="page-title bold">
        信息真实承诺函
      </div>
      <p class="page-content">
        本人申请注册“邀工网”平台账号。本人同意向“邀工网”平台本人个人信息以及队伍相关其他成员（以下统称“队伍成员”）基本信息。
      </p>
      <p class="page-content bold">
        本人承诺：
      </p>
      <p class="page-content">
        1.	本人队伍成员信息均为本人通过合法途径获取，本人有权将该信息上传至“邀工网”平台。
      </p>
      <p class="page-content">
        2.	队伍成员信息均真实有效。
      </p>
      <p class="page-content">
        3.	本人负责队伍成员的维护和管理。
      </p>
      <p class="page-content">
        4.	因注册本队伍、上传队伍成员信息所产生的一切责任均由本人最终承担，与“邀工网”平台无关。
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'aboutUs',
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
  .bold{
    font-weight: bold;
  }

  .static-page {
    height: 100%;
    @include add_size($font_size_16);
    text-align: justify;
  }

  .basic {
    height: 100vh;
    padding-bottom: 40px;
  }

  .page-title {
    margin: 10px 0;
    text-align: center;
  }

  .page-content {
    text-indent: 2em;
    padding-top: 5px;
  }

</style>
